// §29.9 / §9.1 — Burrow as an in-process app.
//
// Manifest only (D-247): the engine, the view, the CSS and the sprite sheet all live behind the
// thunk, so a desktop that never opens this window never downloads any of it (D-199, D-367).
//
// Not a factory. Burrow is single-player — §30.1's multiplayer allowlist does not name it — so it
// needs no `PlayShellAccess` and taking one would imply a session it never opens.
import type { InProcessApp } from '@hangar/shared';
import { createLazyApp } from '@/gamekit/lazy';

export function createBurrowApp(): InProcessApp {
  return createLazyApp({
    app: {
      id: 'burrow',
      name: 'Burrow',
      // §29.1 (D-379) — the glyph is fixed by the roster, not chosen here.
      icon: { glyph: 'shovel', hue: 26 },
      keywords: ['dig', 'tunnels', 'pump', 'rocks', 'underground', 'game', 'arcade'],
      category: 'Arcade',
      // §29.1 (D-369) — the sub-group header this title sits under in the launcher and the Store.
      group: 'Action',
      requiresAuth: true,
      // Fixed-aspect letterboxed canvas (D-229, D-374). The grid is 14 × 16 and every rule in
      // §29.9 is stated in cells — a stretched field would make "within four cells" mean a
      // different distance in a wide window than in a tall one.
      window: { width: 660, height: 780, minWidth: 420, minHeight: 500, multiWindow: false },
      jumpList: [{ id: 'new-game', label: 'New game' }],
    },
    load: () => import('./Burrow'),
  });
}
